<template>
    <div class="current-plan-wrapper">
        <div class="slide-container" v-if="currentPlans.length > 0">
            <div class="slide-content">
                <div class="slide-items" ref="slideItems"
                    @mouseenter="pauseAutoSlide"
                    @mouseleave="resumeAutoSlide">
                    <div class="current-plan-item slide-item" v-for="item in currentPlans" :key="item.currentPlan._id" @click="showPlans">
                        <div class="current-plan-item-head">
                            <div class="current-plan-item-head-left">
                                <div class="current-plan-item-head-left-icon">
                                    <DynamicSvg :name="getIconName()" />
                                </div>
                                <div class="current-plan-item-head-left-title">{{ getTitle() }}</div>
                            </div>
                            <div class="current-plan-item-head-right">
                                <PlanItemButton is-selected>
                                    {{ $t("billing.purchased") }}
                                    <div class="material-icons">check</div>
                                </PlanItemButton>
                            </div>
                        </div>
                        <div class="current-plan-item-footer">
                            <div class="current-plan-item-footer-left">
                                <div class="current-plan-item-footer-left-item" v-if="item.currentPlan.endDate">
                                    <TimeoutIcon />
                                    {{ getRemainingDays(item.currentPlan) }} {{$t('tables.day')}}
                                </div>
                                <a-tooltip placement="topLeft" v-else>
                                    <template slot="title">{{ $t("billing.autoRenew") }}</template>
                                    <div class="current-plan-item-footer-left-item" >
                                        <RenewIcon />
                                    </div>
                                </a-tooltip>
                            </div>
                            <div class="current-plan-item-footer-right">
                                <div class="current-plan-item-footer-right-item solid">
                                    {{ periods[item.currentPlan.period] }}
                                </div>
                                <div
                                    class="current-plan-item-footer-right-item"
                                    v-if="getQuantity().total > 0"
                                >
                                    {{ getQuantity(item).total }} {{ getQuantityText() }}
                                </div>
                                <div
                                    class="current-plan-item-footer-right-item"
                                    v-if="getQuantity().free > 0"
                                >
                                    {{ getQuantity(item).free }} {{ getQuantityText(true) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="slide-controls" v-if="currentPlans.length > 1">
                    <div class="slide-nav">
                        <div class="slide-arrow prev" @click="prevSlide">
                            <i class="material-icons">keyboard_arrow_left</i>
                        </div>
                        <div class="slide-dots">
                            <span
                                v-for="(item, index) in currentPlans"
                                :key="index"
                                class="dot"
                                :class="{ active: currentIndex === index }"
                                @click="goToSlide(index)"
                            ></span>
                        </div>
                        <div class="slide-arrow next" @click="nextSlide">
                            <i class="material-icons">keyboard_arrow_right</i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="current-plan-item" v-else @click="showPlans">
            <div class="current-plan-item-head">
                <div class="current-plan-item-head-left">
                    <div class="current-plan-item-head-left-icon">
                        <DynamicSvg :name="getIconName()" />
                    </div>
                    <div class="current-plan-item-head-left-title">{{ getTitle() }}</div>
                </div>
                <div class="current-plan-item-head-right">
                    <PlanItemButton>{{ $t("billing.buyNow") }}</PlanItemButton>
                </div>
            </div>
            <a-tooltip :title="getDescription()">
                <div class="current-plan-item-description">
                    {{ getDescription() }}
                </div>
            </a-tooltip>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import  moment from "moment";
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import PlanItemButton from "./PlanItemButton.vue";
import RenewIcon from "./svg/RenewIcon.vue";
import TimeoutIcon from "./svg/Timeout.vue";
import { CHANNEL_PLAN_TYPES } from "../utils/util";
export default {
    name: "PlanItem",
    components: { TimeoutIcon, RenewIcon, PlanItemButton, DynamicSvg },
    created(){
        this.getDescription();
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        currentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            currentIndex: 0,
            slideInterval: null,
            slideWidth: 0,
            autoSlidePaused: false,
            isTouching: false,
            touchStartX: 0,
            touchEndX: 0,
            icons: {
                whatsapp: "CWhatsapp",
                "whatsapp-business": "WhatsappBusinessNew",
                supsis: "CSupsis",
                chatbot: "ChatbotNew",
                instagram: "CInstagram",
                telegram: "TelegramEntegration",
                custom: "CSupsis",
                appsumo: "AppSumo",
                messenger: "Messenger",
                trendyol: "trendyol",
                "meta-lead": "MetaIcon",
                "customer-tables": "CustomerTables",
                form: "Form",
                automation: "Automation",
                mail: "Mail",
                tasks: "Tasks",
                "artificial-intelligence": "ArtificialIntelligence",
                "webhook": "WebhookIntegration",
                "linkedin": "LinkedinEntegration",
                "voice-agent": "CAiVoice",
                "webphone": "WebphoneIcon",
            },
            description: {
                whatsapp: this.$t("billing.packageDescriptions.whatsapp"),
                "whatsapp-business": this.$t("billing.packageDescriptions.whatsappBusiness"),
                supsis: this.$t("billing.packageDescriptions.supsis"),
                chatbot: this.$t("billing.packageDescriptions.chatbot"),
                instagram: this.$t("billing.packageDescriptions.instagram"),
                telegram: this.$t("billing.packageDescriptions.telegram"),
                custom: this.$t("billing.packageDescriptions.custom"),
                messenger: this.$t("billing.packageDescriptions.messenger"),
                trendyol: this.$t("billing.packageDescriptions.trendyol"),
                "meta-lead": this.$t("billing.packageDescriptions.metaLead"),
                "customer-tables": this.$t("billing.packageDescriptions.customerTables"),
                form: this.$t("billing.packageDescriptions.form"),
                automation: this.$t("billing.packageDescriptions.automation"),
                mail: this.$t("billing.packageDescriptions.mail"),
                tasks: this.$t("billing.packageDescriptions.tasks"),
                "artificial-intelligence": this.$t("billing.packageDescriptions.artificialIntelligence"),
                "webhook": this.$t("billing.packageDescriptions.webhook"),
                "webphone": "Webphone ile müşterilere çağrı yapabilirsiniz.",
                default: this.$t("billing.packageDescriptions.default"),
            },
            periods: {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                "annual-2": this.$t("billing.twoYearly"),
                forever: this.$t("billing.forever"),
            },
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            features: (state) => state.site.features,
        }),
    },
    mounted() {
        if (this.currentPlans.length > 1) {
            this.$nextTick(() => {
                this.setupSlider();
                this.startAutoSlide();

                const slideItems = this.$refs.slideItems;
                if (slideItems) {
                    slideItems.addEventListener('touchstart', this.handleTouchStart, { passive: true });
                    slideItems.addEventListener('touchmove', this.handleTouchMove, { passive: true });
                    slideItems.addEventListener('touchend', this.handleTouchEnd, { passive: true });
                }
            });
        }
    },
    beforeDestroy() {
        this.stopAutoSlide();

        const slideItems = this.$refs.slideItems;
        if (slideItems) {
            slideItems.removeEventListener('touchstart', this.handleTouchStart);
            slideItems.removeEventListener('touchmove', this.handleTouchMove);
            slideItems.removeEventListener('touchend', this.handleTouchEnd);
        }
    },
    methods: {
        ...mapActions({}),
        setupSlider() {
            const slideItems = this.$refs.slideItems;
            if (slideItems) {
                this.slideWidth = slideItems.clientWidth;
            }
        },
        goToSlide(index) {
            if (index >= 0 && index < this.currentPlans.length) {
                this.currentIndex = index;
                const slideItems = this.$refs.slideItems;
                if (slideItems) {
                    const slideItem = slideItems.querySelector('.slide-item');
                    if (slideItem) {
                        slideItems.style.transform = `translateX(-${index * 100}%)`;
                    }
                }
            }
        },
        prevSlide() {
            const newIndex = this.currentIndex - 1;
            if (newIndex >= 0) {
                this.goToSlide(newIndex);
            } else {
                this.goToSlide(this.currentPlans.length - 1); // Loop to last slide
            }
        },
        nextSlide() {
            const newIndex = this.currentIndex + 1;
            if (newIndex < this.currentPlans.length) {
                this.goToSlide(newIndex);
            } else {
                this.goToSlide(0); // Loop to first slide
            }
        },
        startAutoSlide() {
            this.stopAutoSlide();
            if (this.autoSlidePaused) return;

            this.slideInterval = setInterval(() => {
                this.nextSlide();
            }, 5000);
        },
        stopAutoSlide() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
                this.slideInterval = null;
            }
        },
        pauseAutoSlide() {
            this.autoSlidePaused = true;
            this.stopAutoSlide();
        },
        resumeAutoSlide() {
            this.autoSlidePaused = false;
            if (!this.isTouching) {
                this.startAutoSlide();
            }
        },
        handleTouchStart(event) {
            this.stopAutoSlide();
            this.isTouching = true;
            this.touchStartX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            if (!this.isTouching) return;
            this.touchEndX = event.touches[0].clientX;

            // Sürükleme sırasında kaydırma efekti için
            const diff = this.touchStartX - this.touchEndX;
            const slideItems = this.$refs.slideItems;

            if (slideItems) {
                const currentTranslate = -(this.currentIndex * 100);
                const dragOffset = (diff / slideItems.clientWidth) * 100;
                const newTransform = Math.max(-((this.currentPlans.length - 1) * 100), Math.min(0, currentTranslate - dragOffset));

                slideItems.style.transition = 'none';
                slideItems.style.transform = `translateX(${newTransform}%)`;
            }
        },
        handleTouchEnd() {
            if (!this.isTouching) return;
            this.isTouching = false;

            const diff = this.touchStartX - this.touchEndX;
            const threshold = 50; // minimum distance to recognize as swipe
            const slideItems = this.$refs.slideItems;

            if (slideItems) {
                slideItems.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1)';
            }

            if (diff > threshold) {
                this.nextSlide(); // swipe left
            } else if (diff < -threshold) {
                this.prevSlide(); // swipe right
            } else {
                // Geri çekildi, orijinal konuma dön
                this.goToSlide(this.currentIndex);
            }

            this.startAutoSlide();
        },
        getIconName() {
            return this.icons[this.type] || "CSupsis";
        },
        getTitle() {
            const title = this.type
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            const i18nKey = `message.plans.types.${this.type.replace("-", "_")}`;
            return this.$t(i18nKey) === i18nKey ? title : this.$t(i18nKey);
        },
        getDescription() {
            return this.description[this.type] || this.description.default;
        },
        getRemainingDays(currentPlan) {
            const remainingDays = moment(currentPlan.endDate).diff(moment(), "days");
            return remainingDays;
        },
        isFreePlan(item) {
            const { currentPlan: currentPlanAction, plan } = item;
            const maxUsageCount = currentPlanAction.details?.maxUsageCount;
            const selectFeatures = plan?.selectFeatures || [];
            const currentPlan = selectFeatures.find((feature) => feature.count === maxUsageCount);
            return plan?.isFreePlan || currentPlan?.price <= 0;
        },
        showPlans() {
            this.$router.push({
                path: `/billing/plans/${this.type}`,
            });
        },
        getQuantity() {
            const data = { freeCount: 0, paidCount: 0 };
            if (this.type === "supsis") {
                data.freeCount = this.features.freeAgentCount;
                data.paidCount = this.features.maxAgentCount - this.features.freeAgentCount;
            } else if (this.type === "chatbot") {
                data.paidCount = this.features.totalSessionCount;
            } else if (this.type === "whatsapp") {
                data.paidCount = this.features.maxWhatsappChannel;
            } else if (this.type === "whatsapp-business") {
                data.paidCount = this.features.maxBusinessWhatsappChannel;
            } else if (this.type === "instagram") {
                data.paidCount = this.features.maxInstagramChannel;
            } else if (this.type === "messenger") {
                data.paidCount = this.features.maxMessengerChannel;
            } else if (this.type === "meta-lead") {
                data.paidCount = this.features.maxMetaLeadChannel;
            } else if (this.type === "automation") {
                data.paidCount = this.features.maxAutomationTask;
            } else if (this.type === "trendyol") {
                data.paidCount = this.features.maxTrendyolChannel;
            } else if (this.type === "mail") {
                data.paidCount = this.features.maxMailCount;
            } else if (this.type === "linkedin") {
                data.paidCount = this.features.maxLinkedinChannel;
            } else if (this.type === "telegram") {
                data.paidCount = this.features.maxTelegramChannel;
            } else if (this.type === "webphone") {
                data.paidCount = this.features.maxWebphoneChannel;
            }
            return {
                total: data.freeCount + data.paidCount,
                free: data.freeCount,
                paid: data.paidCount,
            };
        },
        getQuantityText(isFree) {
            let text = "";
            if (this.type === "supsis") {
                text = this.$t("chatWindow.agent");
            } else if (this.type === "chatbot") {
                text = this.$t("report.session");
            } else if (this.type === "automation") {
                text = this.$t("task.task");
            } else if (this.type === "mail") {
                text = this.$t("visitor.mail");
            } else if (CHANNEL_PLAN_TYPES.includes(this.type)) {
                text = this.$t("message.channel");
            } else {
                text = this.$t("message.perPageInFilter");
            }
            return isFree ? `${this.$t("billing.free")} ${text}` : text;
        },
    },
};
</script>
<style lang="scss" scoped>
.current-plan-wrapper {
    background: white;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    border: none;
}

.slide-container {
    width: 100%;
    position: relative;
}

.slide-content {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    padding-bottom: 20px; /* Kontroller için alan */
    touch-action: pan-y;
    background: white;
}

.slide-items {
    display: flex;
    transition: transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
    width: 100%;
    will-change: transform;
}

.slide-item {
    flex: 0 0 100%;
    min-width: 100%;
}

.slide-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    z-index: 2;
    padding-bottom: 5px;
}

.slide-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(240, 240, 240, 0.7);
    border-radius: 20px;
    padding: 2px 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

.slide-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 5px;

    .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #CCCCCC;
        margin: 0 3px;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
            background: #5625CC;
            width: 8px;
            height: 8px;
        }

        &:hover {
            background: #AAAAAA;
        }
    }
}

.slide-arrow {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: transparent;
    box-shadow: none;
    transition: all 0.2s ease;

    i {
        font-size: 14px;
        color: #7B45DD;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &:hover {
        background: rgba(86, 37, 204, 0.1);

        i {
            color: #5625CC;
        }
    }

    &:active {
        transform: scale(0.95);
    }
}

.current-plan-item {
    width: 100%;
    cursor: pointer;

    &-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 10px;
        border-bottom: 1px solid #F1F4F7;
        background: white;

        &-left {
            display: flex;
            align-items: center;
            gap: 10px;

            &-icon {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    width: 100%;
                    height: 100%;
                }
            }

            &-title {
                font-size: 16px;
                font-weight: bold;
                text-wrap: nowrap;
                color: inherit;
            }
        }
    }

    &-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;

        &-left {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 12px;

            &-item {
                display: flex;
                align-items: center;
                gap: 3px;
            }
        }

        &-right {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 12px;

            &-item {
                display: flex;
                align-items: center;
                gap: 3px;
                border: 1px solid #F1F4F7;
                color: #647491;
                padding: 0 4px;

                &.free-item {
                    color: #1BB157;
                }

                &.solid {
                    background: inherit;
                }
            }
        }
    }

    &-description {
        padding: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 64px;
        font-size: 12px;
        color: #8796AF;
        background: white;
    }
}

@media (max-width: 768px) {
    .slide-content {
        padding-bottom: 25px;
    }

    .slide-controls {
        padding-bottom: 8px;
    }

    .slide-nav {
        background: rgba(240, 240, 240, 0.8);
        padding: 3px 6px;
    }

    .slide-dots .dot {
        width: 7px;
        height: 7px;
        margin: 0 4px;

        &.active {
            width: 9px;
            height: 9px;
        }
    }

    .slide-arrow {
        width: 24px;
        height: 24px;
        margin: 0 1px;

        i {
            font-size: 16px;
        }
    }
}
</style>
